export default defineNuxtPlugin({
  setup() {
    const headers = useRequestHeaders(['cookie'])

    const $api = $fetch.create({
      headers,
      async onRequest({ options }) {
        options.headers.set('x-url', useRequestURL().toString())
        options.headers.set('x-request-source', 'website')

        if (import.meta.client) {
          options.headers.set('x-navigator-language', navigator.language)
          options.headers.set('x-date-time-locale', Intl.DateTimeFormat().resolvedOptions().locale)
        }
      },
      async onRequestError({ error }) {
        // TODO handle request errors
        console.error(error)
      },
      async onResponseError({ response }) {
        if (response.status === 401) {
          throw new FetchErrorUnauthorized(response.status, response.statusText)
        }
        else if (response._data?.uuid && response._data?.path) {
          throw new FetchErrorServer(response.status, response.statusText, response._data.uuid, response._data.path)
        }
        else {
          throw new FetchErrorMisc(response.status, response.statusText)
        }
      },
    })

    return {
      provide: {
        api: $api,
      },
    }
  },
})
